import { IBundleEntityTags } from '~/types/bundle';

export const getProgressionRewardBonus = (entities: IBundleEntity[] = []) => {
    return entities.find((entity) => entity.tags?.includes(IBundleEntityTags.progression_reward));
};
